import React from 'react'

import { Modal, Table, Button, Form } from '_zari/core'

import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import { IdGen } from 'utils'

import * as GuiasVentaService from 'services/guiasVenta.service'

const ListaGuiasModal = ({ show, handleClose, idSocio, dispatch, setFieldValue, reiniciarFormularioMontos }) => {
  const [listaGuias, setListaGuias] = React.useState([])
  const [idsSeleccionados, setIdsSeleccionados] = React.useState([])

  React.useEffect(() => {
    GuiasVentaService.getGuias_ParaVenta(idSocio).then(({ data }) => {
      setListaGuias(data)
    })
  }, [idSocio])

  const changeChecked = React.useCallback(({ _id }) => {
    setIdsSeleccionados(prev => {
      let newValues = [...prev]

      const existe = newValues.some(x => x === _id)

      if (existe) {
        newValues = newValues.filter(x => x !== _id)
      } else {
        newValues.push(_id)
      }

      return newValues
    })
  }, [])

  const clickSeleccionar = React.useCallback(() => {
    GuiasVentaService.getDetalles_ParaVenta(idsSeleccionados).then(({ data }) => {
      const detalles = data.map(({ _id, ...x }) => {
        return {
          ...x,
          _idFila: IdGen.newId()
        }
      })

      setFieldValue('idsGuias', idsSeleccionados)
      setFieldValue('flagPorGuias', true)

      dispatch({ type: 'fill', payload: detalles })

      reiniciarFormularioMontos()

      handleClose()
    })
  }, [idsSeleccionados, dispatch, handleClose, setFieldValue, reiniciarFormularioMontos])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>LISTA GUIAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          maxRowsShown={15}
          filas={listaGuias}
          headRows={[{ label: '' }, { label: 'FECHA' }, { label: 'TIPO DOCUMENTO' }, { label: 'SERIE-NUMERO' }]}
          rowTemplate={row => (
            <Table.Row key={IdGen.newId()}>
              <Table.Cell>
                <Form.Checkbox
                  id={`checkbox-${row._id}`}
                  name='idsGuia'
                  label=''
                  value={row._id}
                  checked={idsSeleccionados.some(x => x === row._id)}
                  onChange={e => changeChecked({ _id: row._id })}
                />
              </Table.Cell>
              <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
              <Table.Cell>
                {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
              </Table.Cell>
              <Table.Cell>{`${row.serieDocumento} - ${row.numeroDocumento}`}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button disabled={idsSeleccionados.length === 0} onClick={clickSeleccionar}>
          Seleccionar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ListaGuiasModal)
